import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import EditProperty from './EditProperty'
import RoleControlled from '../_common/RoleControlled'
import BackButton from '../_common/BackButton'

import { deleteDetails, fetchDetails, postCSV } from '../../actions'
import Modal from '../_common/Modal'
import { PREFECTURES } from '../../const'
import CSV from '../../assets/files/m_resident.csv'

class PropertyDetails extends PureComponent {
  constructor (props) {
    super(props)

    this.state = {
      showGuestInfo: false,
      editMode: false
    }
  }

  _handleDeleteClick () {
    const res = window.confirm('削除しますか？')
    if (res) {
      console.log('delete id: ', this.props.activeDetails.data.property_id)
      const redirect = () => {
        this.props.history.replace('/properties')
      }
      this.props.deleteDetails('properties', this.props.activeDetails.data.property_id, redirect.bind(this))
    }
  }
  _handleEditClick () {
    this.setState({ editMode: true })
  }
  _handleSaveEditClick (id) {
    this.setState({ editMode: false })
    // const { category, id } = this.props.match.params
    // this.props.fetchDetails('properties', id)
  }
  _handleDisableEditMode () {
    this.setState({ editMode: false })
  }
  _handleShowIdClick () {
    this.setState({ showGuestInfo: true })
  }
  _handleHideId () {
    this.setState({ showGuestInfo: false })
  }
  _handleAddCsv (e) {
    const csv = e.target.files[0]
    console.log(csv)
    if (csv) {
      if (csv.type === 'text/csv' && csv.name.indexOf('csv') > 0) {
        // this.setState({ image, imageURL: URL.createObjectURL(image) })
        console.log('sending csv file')
        this.props.postCSV({ category_id: 1 }, csv)
      } else {
        console.log('wrong file type')
        // this.setState({ image_error: '画像ファイル外を選択しました。\n確認の上でもう一度画像ファイルを選択してください。' })
      }
    }
  }

  _renderModal () {
    const { guest_id, guest_password } = this.props.activeDetails.data
    if (this.state.showGuestInfo) {
      return (
        <Modal
          title="ゲストログイン情報"
          closeModal={this._handleHideId.bind(this)}
          noBtn
        >
          <div className="guest_info">
            <div className="guest_id">URL：<a href="https://app.buffalo-its.jp" target="_blank" rel="noopener noreferrer">https://app.buffalo-its.jp</a></div>
            <div className="guest_id">ID：{guest_id}</div>
            <div className="guest_pwd">パスワード：{guest_password}</div>

          </div>
        </Modal>
      )
    }
    return null
  }

  _renderData () {
    const dataLabels = [
      {
        key: 'bits_property_id',
        label: 'BITS物件ID'
      },
      {
        key: 'property_name',
        label: '物件名'
      },
      {
        key: 'owner_id',
        label: 'オーナーID'
      },
      {
        key: 'room_count',
        label: '総世帯数'
      },
      {
        key: 'pref_id',
        label: '都道府県'
      },
      {
        key: 'address',
        label: '住所'
      },
      {
        key: 'contact_tel',
        label: '問合せ先電話番号'
      },
      {
        key: 'contact_email',
        label: 'メールアドレス'
      },
      {
        key: 'image',
        label: 'メインビジュアル画像'
      }
    ]

    const { data } = this.props.activeDetails
    // console.log('data: ', data)
    return dataLabels.map(item => {
      // console.log('item: ', item)
      if (item.key === 'image') {
        return (
          <div className="group" key={item.key}>
            <div className="label">{ item.label }</div>
            <div className="value medium img_container">
              <img className="img_responsive" src={ data[item.key] } alt="" />
            </div>
          </div>
        )
      }

      if (item.key === 'pref_id') {
        const prefectureName = _.find(PREFECTURES, { code: data[item.key] })
        if (prefectureName) {
          return (
            <div className="group" key={item.key}>
              <div className="label">{ item.label }</div>
              <div className="value medium">{ prefectureName.name }</div>
            </div>
          )
        }
      }

      return (
        <div className="group" key={item.key}>
          <div className="label">{ item.label }</div>
          <div className="value medium">{ data[item.key] }</div>
        </div>
      )
    })
  }

  _renderBtns () {
    const id = this.props.activeDetails.data.property_id
    return (
      <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
        <div className="btn_group">
          <button className="btn secondary flex align-center" onClick={this._handleShowIdClick.bind(this)}>
            <svg viewBox="0 0 24 24" className="icon_send">
              <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
              <circle cx="12" cy="12" r="3"></circle>
            </svg>
            <span>オーナーの閲覧用URL・ログイン情報を表示する</span>
          </button>
          <Link to={`/properties/${id}/residents`} className="btn primary flex align-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="icon-add">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            <span>この物件の入居者情報を追加する</span>
          </Link>
          <label htmlFor="add_csv" className="btn download_btn flex align-center">
            <svg viewBox="0 0 24 24" className="icon_upload">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
              <polyline points="17 8 12 3 7 8"></polyline>
              <line x1="12" y1="3" x2="12" y2="15"></line>
            </svg>
            <span>CSVでこの物件の入居者情報を追加する</span>
          </label>
          <a className="small csv_example" href={CSV}>CSVのフォーマットをダウンロード</a>
          <input
            type="file"
            id="add_csv"
            onChange={this._handleAddCsv.bind(this)}
          />
        </div>
      </RoleControlled>
    )
  }

  _renderMemo () {
    return (
      <div className="group memo_group">
        <div className="label">メモ</div>
        <div className="memo">{ this.props.activeDetails.data.memo }</div>
      </div>
    )
  }
  _renderEditForm () {
    return <EditProperty data={this.props.activeDetails.data} close={this._handleDisableEditMode.bind(this)} save={this._handleSaveEditClick.bind(this)}/>
  }

  _renderDetails () {
    return (
      <article>
        { this._renderModal() }
        <div className="details_outer flex">
          <div className="details_right">
            { this._renderBtns() }
            { this._renderMemo() }
          </div>
          <div className="details_left">
            { this._renderData() }

            <div className="group">
              <div className="label">作成日</div>
              <div className="value medium">{ this.props.activeDetails.data.created_date }</div>
            </div>
          </div>
        </div>

        <div className="button_container flex">
          <BackButton />
          <RoleControlled role={this.props.user.user_role} acceptedRoles={[0, 1]}>
            <button className="btn edit primary flex" onClick={this._handleEditClick.bind(this)}>
              <svg viewBox="0 0 24 24" className="icon_edit">
                <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"></path>
                <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"></polygon>
              </svg>
              <span>編集</span>
            </button>
            <button className="btn delete red flex" onClick={this._handleDeleteClick.bind(this)}>
              <svg viewBox="0 0 24 24" className="icon_edit">
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
              <span>削除</span>
            </button>
          </RoleControlled>
        </div>
      </article>
    )
  }

  render () {
    return this.state.editMode
      ? this._renderEditForm()
      : this._renderDetails()
  }
}
// export default PropertyDetails

function mapStateToProps ({ user, activeDetails }) {
  return { user, activeDetails }
}

export default connect(mapStateToProps, { deleteDetails, fetchDetails, postCSV })(PropertyDetails)



// WEBPACK FOOTER //
// ./src/components/Properties/PropertyDetail.js